// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advancedOptions_WNLwA {
  background-color: var(--white-background);
  border-radius: 8px;
  box-shadow: 0 2px 4px var(--_0000001a-shadow);
  overflow: visible;
}

.description_rdwDj {
  font-size: 0.8rem;
  color: #71717A !important; 
  margin-bottom: 20px;
  text-align: left;
  line-height: 1.5;
  opacity: 0.85;
}

.smallDescription_hflsD {
  font-size: 0.8rem;
  color: #71717A !important; 
  margin-top: 8px;
  text-align: left;
  line-height: 1.3;
  opacity: 0.85;
}

.optionGroup_KkTBc {
  margin-bottom: 20px;
  overflow: visible;
}

.label_MpEQ2 {
  display: block;
  font-size: 0.9rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: left;
}

.buttonGrid__nX2z {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}

.shapeButton_Ct9yt {
  padding: 20px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: var(--f9fafb-background);
  color: #333;
  font-size: 0.9rem;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
  text-align: center;
  white-space: nowrap;
  flex: 1 1;
  min-width: 120px;
  max-width: 250px;
  box-sizing: border-box;
}

.shapeButton_Ct9yt:hover {
  border-color: #b6b6b6;
  background-color: var(--f5-background);
  color: #333;
}

.shapeButton_Ct9yt.selected_xyFfV {
  border-color: transparent;
  background-color: var(--f5-background);
  font-weight: 600;
}

.inlineGroup_Ay703 {
  display: flex;
  gap: 16px;
  align-items: flex-end;
}

.inlineGroup_Ay703 > .optionGroup_KkTBc {
  margin-bottom: 0;
  flex: 1 1;
}




@media (max-width: 1200px) {
  .shapeButton_Ct9yt {
    padding: 18px 12px;
    min-width: 110px;
    max-width: 220px;
  }
}

@media (max-width: 1024px) {
  .description_rdwDj {
    font-size: 0.85rem;
    margin-bottom: 18px;
  }

  .smallDescription_hflsD {
    font-size: 0.85rem;
    margin-top: 6px;
  }

  .label_MpEQ2 {
    font-size: 0.85rem;
    margin-bottom: 6px;
  }

  .shapeButton_Ct9yt {
    padding: 16px 10px;
    font-size: 0.85rem;
    min-width: 100px;
    max-width: 200px;
  }

  .optionGroup_KkTBc {
    margin-bottom: 18px;
  }
}

@media (max-width: 768px) {
  .description_rdwDj {
    font-size: 0.8rem;
    margin-bottom: 16px;
    line-height: 1.4;
    color: #71717A;
    opacity: 0.85;
  }

  .smallDescription_hflsD {
    font-size: 0.9rem;
    margin-top: 6px;
    line-height: 1.2;
    color: #71717A;
    opacity: 0.85;
  }

  .optionGroup_KkTBc {
    margin-bottom: 16px;
  }

  .label_MpEQ2 {
    font-size: 0.8rem;
    margin-bottom: 6px;
  }

  .buttonGrid__nX2z {
    gap: 8px;
  }

  .shapeButton_Ct9yt {
    padding: 16px 12px;
    font-size: 0.8rem;
    flex: 1 1;
    min-width: 100px;
    max-width: none;
  }

  .inlineGroup_Ay703 {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .inlineGroup_Ay703 > .optionGroup_KkTBc {
    margin-bottom: 12px;
  }

}
  
@media (max-width: 480px) {
  .description_rdwDj {
    font-size: 0.75rem;
    margin-bottom: 12px;
    color: #6b7280;
    opacity: 0.85;
  }

  .buttonGrid__nX2z {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .shapeButton_Ct9yt {
    padding: 12px 10px;
    font-size: 0.75rem;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
  }

  .inlineGroup_Ay703 {
    gap: 8px;
  }

  .optionGroup_KkTBc {
    margin-bottom: 12px;
  }

  .label_MpEQ2 {
    font-size: 0.75rem;
    margin-bottom: 4px;
  }

  .smallDescription_hflsD {
    font-size: 0.8rem;
    margin-top: 4px;
    color: #9ca3af;
    opacity: 0.85;
  }
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/AdvancedOptions/AdvancedOptions.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf;8BAC4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;;;;AAKA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,SAAO;IACP,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;EACf;AACF","sourcesContent":[".advancedOptions {\n  background-color: var(--white-background);\n  border-radius: 8px;\n  box-shadow: 0 2px 4px var(--_0000001a-shadow);\n  overflow: visible;\n}\n\n.description {\n  font-size: 0.8rem;\n  color: #71717A !important; \n  margin-bottom: 20px;\n  text-align: left;\n  line-height: 1.5;\n  opacity: 0.85;\n}\n\n.smallDescription {\n  font-size: 0.8rem;\n  color: #71717A !important; \n  margin-top: 8px;\n  text-align: left;\n  line-height: 1.3;\n  opacity: 0.85;\n}\n\n.optionGroup {\n  margin-bottom: 20px;\n  overflow: visible;\n}\n\n.label {\n  display: block;\n  font-size: 0.9rem;\n  color: #333;\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-align: left;\n}\n\n.buttonGrid {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.shapeButton {\n  padding: 20px 14px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background-color: var(--f9fafb-background);\n  color: #333;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease,\n    background-color 0.2s ease;\n  text-align: center;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 120px;\n  max-width: 250px;\n  box-sizing: border-box;\n}\n\n.shapeButton:hover {\n  border-color: #b6b6b6;\n  background-color: var(--f5-background);\n  color: #333;\n}\n\n.shapeButton.selected {\n  border-color: transparent;\n  background-color: var(--f5-background);\n  font-weight: 600;\n}\n\n.inlineGroup {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n}\n\n.inlineGroup > .optionGroup {\n  margin-bottom: 0;\n  flex: 1;\n}\n\n\n\n\n@media (max-width: 1200px) {\n  .shapeButton {\n    padding: 18px 12px;\n    min-width: 110px;\n    max-width: 220px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .description {\n    font-size: 0.85rem;\n    margin-bottom: 18px;\n  }\n\n  .smallDescription {\n    font-size: 0.85rem;\n    margin-top: 6px;\n  }\n\n  .label {\n    font-size: 0.85rem;\n    margin-bottom: 6px;\n  }\n\n  .shapeButton {\n    padding: 16px 10px;\n    font-size: 0.85rem;\n    min-width: 100px;\n    max-width: 200px;\n  }\n\n  .optionGroup {\n    margin-bottom: 18px;\n  }\n}\n\n@media (max-width: 768px) {\n  .description {\n    font-size: 0.8rem;\n    margin-bottom: 16px;\n    line-height: 1.4;\n    color: #71717A;\n    opacity: 0.85;\n  }\n\n  .smallDescription {\n    font-size: 0.9rem;\n    margin-top: 6px;\n    line-height: 1.2;\n    color: #71717A;\n    opacity: 0.85;\n  }\n\n  .optionGroup {\n    margin-bottom: 16px;\n  }\n\n  .label {\n    font-size: 0.8rem;\n    margin-bottom: 6px;\n  }\n\n  .buttonGrid {\n    gap: 8px;\n  }\n\n  .shapeButton {\n    padding: 16px 12px;\n    font-size: 0.8rem;\n    flex: 1;\n    min-width: 100px;\n    max-width: none;\n  }\n\n  .inlineGroup {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  .inlineGroup > .optionGroup {\n    margin-bottom: 12px;\n  }\n\n}\n  \n@media (max-width: 480px) {\n  .description {\n    font-size: 0.75rem;\n    margin-bottom: 12px;\n    color: #6b7280;\n    opacity: 0.85;\n  }\n\n  .buttonGrid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 6px;\n  }\n\n  .shapeButton {\n    padding: 12px 10px;\n    font-size: 0.75rem;\n    min-width: 0;\n    max-width: 100%;\n    white-space: normal;\n  }\n\n  .inlineGroup {\n    gap: 8px;\n  }\n\n  .optionGroup {\n    margin-bottom: 12px;\n  }\n\n  .label {\n    font-size: 0.75rem;\n    margin-bottom: 4px;\n  }\n\n  .smallDescription {\n    font-size: 0.8rem;\n    margin-top: 4px;\n    color: #9ca3af;\n    opacity: 0.85;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"advancedOptions": `advancedOptions_WNLwA`,
	"description": `description_rdwDj`,
	"smallDescription": `smallDescription_hflsD`,
	"optionGroup": `optionGroup_KkTBc`,
	"label": `label_MpEQ2`,
	"buttonGrid": `buttonGrid__nX2z`,
	"shapeButton": `shapeButton_Ct9yt`,
	"selected": `selected_xyFfV`,
	"inlineGroup": `inlineGroup_Ay703`
};
export default ___CSS_LOADER_EXPORT___;
